var map = {
	"./Frame.png": 3236,
	"./Mask group@2x.png": 9706,
	"./QuestionMark.png": 5868,
	"./StarImg.png": 4574,
	"./Vector (2).png": 8173,
	"./Vector (3).png": 230,
	"./Vector (7).png": 7258,
	"./Vector.png": 302,
	"./Vector_bookmark.png": 3059,
	"./Vector_left.png": 9848,
	"./accepet.png": 8884,
	"./accept.png": 819,
	"./article.png": 8893,
	"./bookmark1.png": 9218,
	"./bookmark2.png": 185,
	"./calender.png": 2133,
	"./call-icon.png": 4921,
	"./camera-off.png": 7154,
	"./camera-on.png": 1326,
	"./cancel-red.png": 2423,
	"./cancel.png": 421,
	"./cartadded.png": 3999,
	"./cartempty.png": 2634,
	"./chat-icon.png": 1071,
	"./chat-send.png": 9330,
	"./chatAttachment.png": 8250,
	"./chatroom-background.png": 4775,
	"./completeTask.png": 3609,
	"./copy.png": 6748,
	"./darkchat.png": 6317,
	"./disconnectcall.png": 7361,
	"./documentation.png": 5469,
	"./docxx.png": 4521,
	"./doller.png": 669,
	"./email.png": 5075,
	"./endcall.png": 528,
	"./expert.png": 9651,
	"./expertbord.png": 9788,
	"./eye_icon.png": 2226,
	"./filter.png": 133,
	"./findTutor.png": 8528,
	"./flowQueryimg.png": 6706,
	"./forward_icon.png": 5786,
	"./getQualified.png": 9725,
	"./google.png": 446,
	"./home.png": 3886,
	"./icon_large (2).png": 95,
	"./icons8-bullseye 1.png": 1760,
	"./icons8-thinking 2 (1).png": 4544,
	"./icons8-tick.png": 1031,
	"./icons8-video-call 1.png": 6747,
	"./knlodgeidentity.png": 2597,
	"./learnatrecess.png": 915,
	"./lib.png": 1838,
	"./libwhite.png": 5091,
	"./lock-icon.png": 5002,
	"./lock.png": 4966,
	"./loopQueryImg.png": 4952,
	"./man (1).png": 6101,
	"./manageAccount.png": 5485,
	"./mic.png": 2298,
	"./microphone.png": 1595,
	"./microphoneOff.png": 8092,
	"./no-video.png": 6484,
	"./nomage.png": 3752,
	"./normalcall.png": 3090,
	"./notification.png": 7782,
	"./occ-black.png": 2692,
	"./on-video.png": 1470,
	"./picture.png": 165,
	"./policy.png": 4653,
	"./query_image1.png": 7452,
	"./query_image2.png": 5559,
	"./refresh.png": 6874,
	"./reject.png": 9978,
	"./rightarrow.png": 1438,
	"./search bar.png": 7920,
	"./search.png": 2671,
	"./setting.png": 8503,
	"./settings.png": 6684,
	"./share-black.png": 8996,
	"./share-screen.png": 9,
	"./share.png": 3002,
	"./sign-in.png": 6018,
	"./sign-out.png": 4195,
	"./smalltick.png": 9233,
	"./sort.png": 9511,
	"./spekaron.png": 2516,
	"./strightwaves.png": 194,
	"./striplogo.png": 5648,
	"./support 2.png": 4316,
	"./termsandconditions.png": 7617,
	"./tick.png": 3868,
	"./verified.png": 6135,
	"./vid-icon.png": 2922,
	"./video_cancel.png": 5241,
	"./videocall.png": 1034,
	"./videoconnect.png": 3502,
	"./videos.png": 9931,
	"./volume-down.png": 4404,
	"./volume.png": 5781,
	"./wallet.png": 6516,
	"./waves.png": 2249,
	"./white-arrow.png": 7384,
	"./white-occ.png": 8394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2568;